import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import AdSenseUnit from "@/components/AdSenseUnit";
import ContentPageFooter from "@/components/ContentPageFooter";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const faqs = t("faq.items", { returnObjects: true }) as {
    q: string;
    a: string;
  }[];

  return (
    <div className="min-h-screen bg-background text-foreground px-4 py-6 pb-24">
      <Helmet>
        <title>FAQ – Ayeris Help & Support</title>
        <meta name="description" content="Find answers to common questions about Ayeris. Learn how to discover movies and TV shows, manage your account, and more." />
        <link rel="canonical" href="https://ayeris.tv/faq" />
      </Helmet>
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition mb-6"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="text-sm">{t("common.back", "Back")}</span>
      </button>

      <h1 className="text-2xl font-display font-bold mb-2">{t("faq.title")}</h1>
      <p className="text-sm text-muted-foreground mb-6">{t("faq.subtitle")}</p>

      <Accordion type="single" collapsible className="space-y-2">
        {Array.isArray(faqs) &&
          faqs.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border border-border rounded-xl px-4 bg-card overflow-hidden"
            >
              <AccordionTrigger className="text-sm font-medium text-foreground text-left py-4 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-secondary-foreground leading-relaxed pb-4">
                <span dangerouslySetInnerHTML={{ __html: item.a }} />
              </AccordionContent>
            </AccordionItem>
          ))}
      </Accordion>

      <AdSenseUnit adSlot="5004064879" className="my-6" />

      <div className="mt-8 p-4 rounded-xl bg-secondary/50 border border-border text-center">
        <p className="text-sm text-muted-foreground mb-1">{t("faq.stillStuck")}</p>
        <a
          href="mailto:support@ayeris.tv"
          className="text-sm text-primary font-medium hover:underline"
        >
          support@ayeris.tv
        </a>
      </div>

      <ContentPageFooter currentPath="/faq" />
    </div>
  );
};

export default FAQ;
